import { combineReducers } from "redux"
import { themes } from './themeReducer'

const themeReducers = combineReducers({
    themes,
})

export default themeReducers